module.exports = __webpack_public_path__ + "static/media/Tischdecke_140x140.2ff9acf6.png";